module.exports = __webpack_public_path__ + "static/burg3-b352b43baf45f30b9c7cc5f423a9abe6.jpg";